// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/PalaceScriptMT.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/menu_background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Menu.css */
@font-face {
  font-family: 'Palace Script MT';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

#menu {
  font-family: 'Lato', sans-serif;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center fixed;
  background-size: cover;
  padding: 4rem 2rem;
  border-radius: 10px;
  max-width: 900px;
  margin: 0 auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1; /* Ensure it is above any background overlays */
  color: #000; /* Ensure text color is black for readability */
  animation: fadeIn 1s ease-in; /* Add fade-in animation */
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.menu-header,
.menu-section,
.pagination,
.reset-button {
  position: relative;
  z-index: 2; /* Ensure the content is above the overlay */
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem; /* Space between header and menu content */
}

.menu-title {
  font-family: 'Palace Script MT', cursive;
  font-size: 6rem; /* Adjust size */
  color: #000; /* Change to black for better readability */
  text-align: left;
  cursor: pointer;
}

.menu-logo {
  height: 150px; /* Adjust size */
}

.menu-section {
  margin-bottom: 3rem; /* Space between sections */
}

.menu-section h2, .menu-section h4, .menu-section h5 {
  font-size: 1.75rem;
  color: #000; /* Change to black for better readability */
  border-bottom: 2px solid #000; /* Change to black for better readability */
  padding-bottom: 0.5rem;
  margin-top: 1.5rem;
  font-weight: bold;
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.menu-section h3 {
  font-size: 1.5rem;
  color: #000; /* Change to black for better readability */
  border-bottom: 2px solid #000; /* Change to black for better readability */
  padding-bottom: 0.5rem;
  margin-top: 1.5rem;
}

.menu-section ul {
  list-style-type: none;
  padding: 0;
}

.menu-section ul li {
  font-size: 1.25rem;
  font-family: Georgia, 'Times New Roman', Times, serif;
  padding: 0.5rem 0;
  color: #000; /* Change to black */
}

.menu-item-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* Allow wrapping */
}

.menu-item-name {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap; /* Allow wrapping */
}

.menu-item-name .title-break {
  display: none;
}

.menu-item-slash {
  white-space: nowrap;
}

.menu-item-dots {
  flex: 1 1;
  border-bottom: 1px dotted #ccc;
  margin: 0 10px;
}

.menu-item-price {
  flex: 0 0 auto;
  white-space: nowrap;
  padding-left: 10px;
  text-align: right;
  font-weight: bold;
}

.menu-item-price-part {
  display: block;
}

.menu-section ul li small {
  font-size: 0.9rem;
  color: #555; /* Darker gray */
  display: block;
  margin-top: 5px;
  margin-left: 1.5rem; /* Indent for better readability */
}

.menu-section ul li:last-child {
  border-bottom: none;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.pagination button {
  background-color: #343a40; /* Same color as navbar bg-dark */
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0 0.5rem;
  cursor: pointer;
  border-radius: 5px;
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.pagination button:disabled {
  background-color: #4b545e;
  cursor: not-allowed;
}

.pagination span {
  font-size: 1.25rem;
  color: #000; /* Change to black */
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.reset-button {
  text-align: center;
  margin-top: 1rem;
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.reset-button button {
  background-color: #343a40; /* Same color as navbar bg-dark */
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 5px;
}

@media (max-width: 768px) {
  #menu {
    padding: 3rem 1rem; /* Adjust padding for smaller screens */
  }

  .menu-title {
    font-size: 4rem; /* Adjust size for smaller screens */
  }

  .menu-logo {
    height: 100px; /* Adjust size for smaller screens */
  }

  .menu-section h2 {
    font-size: 1.5rem !important;
  }

  .menu-section ul li {
    font-size: 1rem;
  }

  .pagination span {
    font-size: 1rem;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/Menu.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,+BAA+B;EAC/B,+DAAoE;AACtE;;AAEA;EACE,+BAA+B;EAC/B,iFAAiF;EACjF,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU,EAAE,+CAA+C;EAC3D,WAAW,EAAE,+CAA+C;EAC5D,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU,EAAE,4CAA4C;AAC1D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAE,0CAA0C;AACjE;;AAEA;EACE,wCAAwC;EACxC,eAAe,EAAE,gBAAgB;EACjC,WAAW,EAAE,2CAA2C;EACxD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,gBAAgB;AACjC;;AAEA;EACE,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,2CAA2C;EACxD,6BAA6B,EAAE,2CAA2C;EAC1E,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,WAAW,EAAE,2CAA2C;EACxD,6BAA6B,EAAE,2CAA2C;EAC1E,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,iBAAiB;EACjB,WAAW,EAAE,oBAAoB;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe,EAAE,mBAAmB;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe,EAAE,mBAAmB;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW,EAAE,gBAAgB;EAC7B,cAAc;EACd,eAAe;EACf,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,oBAAoB;EACjC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB,EAAE,uCAAuC;EAC7D;;EAEA;IACE,eAAe,EAAE,oCAAoC;EACvD;;EAEA;IACE,aAAa,EAAE,oCAAoC;EACrD;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* Menu.css */\n@font-face {\n  font-family: 'Palace Script MT';\n  src: url('../../assets/fonts/PalaceScriptMT.ttf') format('truetype');\n}\n\n#menu {\n  font-family: 'Lato', sans-serif;\n  background: url('../../assets/menu_background.jpg') no-repeat center center fixed;\n  background-size: cover;\n  padding: 4rem 2rem;\n  border-radius: 10px;\n  max-width: 900px;\n  margin: 0 auto;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1; /* Ensure it is above any background overlays */\n  color: #000; /* Ensure text color is black for readability */\n  animation: fadeIn 1s ease-in; /* Add fade-in animation */\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.menu-header,\n.menu-section,\n.pagination,\n.reset-button {\n  position: relative;\n  z-index: 2; /* Ensure the content is above the overlay */\n}\n\n.menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem; /* Space between header and menu content */\n}\n\n.menu-title {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 6rem; /* Adjust size */\n  color: #000; /* Change to black for better readability */\n  text-align: left;\n  cursor: pointer;\n}\n\n.menu-logo {\n  height: 150px; /* Adjust size */\n}\n\n.menu-section {\n  margin-bottom: 3rem; /* Space between sections */\n}\n\n.menu-section h2, .menu-section h4, .menu-section h5 {\n  font-size: 1.75rem;\n  color: #000; /* Change to black for better readability */\n  border-bottom: 2px solid #000; /* Change to black for better readability */\n  padding-bottom: 0.5rem;\n  margin-top: 1.5rem;\n  font-weight: bold;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n.menu-section h3 {\n  font-size: 1.5rem;\n  color: #000; /* Change to black for better readability */\n  border-bottom: 2px solid #000; /* Change to black for better readability */\n  padding-bottom: 0.5rem;\n  margin-top: 1.5rem;\n}\n\n.menu-section ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.menu-section ul li {\n  font-size: 1.25rem;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  padding: 0.5rem 0;\n  color: #000; /* Change to black */\n}\n\n.menu-item-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap; /* Allow wrapping */\n}\n\n.menu-item-name {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap; /* Allow wrapping */\n}\n\n.menu-item-name .title-break {\n  display: none;\n}\n\n.menu-item-slash {\n  white-space: nowrap;\n}\n\n.menu-item-dots {\n  flex: 1;\n  border-bottom: 1px dotted #ccc;\n  margin: 0 10px;\n}\n\n.menu-item-price {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  padding-left: 10px;\n  text-align: right;\n  font-weight: bold;\n}\n\n.menu-item-price-part {\n  display: block;\n}\n\n.menu-section ul li small {\n  font-size: 0.9rem;\n  color: #555; /* Darker gray */\n  display: block;\n  margin-top: 5px;\n  margin-left: 1.5rem; /* Indent for better readability */\n}\n\n.menu-section ul li:last-child {\n  border-bottom: none;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.pagination button {\n  background-color: #343a40; /* Same color as navbar bg-dark */\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin: 0 0.5rem;\n  cursor: pointer;\n  border-radius: 5px;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n.pagination button:disabled {\n  background-color: #4b545e;\n  cursor: not-allowed;\n}\n\n.pagination span {\n  font-size: 1.25rem;\n  color: #000; /* Change to black */\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n.reset-button {\n  text-align: center;\n  margin-top: 1rem;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n.reset-button button {\n  background-color: #343a40; /* Same color as navbar bg-dark */\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n@media (max-width: 768px) {\n  #menu {\n    padding: 3rem 1rem; /* Adjust padding for smaller screens */\n  }\n\n  .menu-title {\n    font-size: 4rem; /* Adjust size for smaller screens */\n  }\n\n  .menu-logo {\n    height: 100px; /* Adjust size for smaller screens */\n  }\n\n  .menu-section h2 {\n    font-size: 1.5rem !important;\n  }\n\n  .menu-section ul li {\n    font-size: 1rem;\n  }\n\n  .pagination span {\n    font-size: 1rem;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
